import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
function convertBoolean(val: string) {
	return val === 'true';
}
@Injectable({
	providedIn: 'root'
})
export class MainNavService {
	private _navMin = new BehaviorSubject<boolean>(convertBoolean(localStorage.getItem('main-nav-min')));
	navMin = this._navMin.pipe(
		tap(v => {
			localStorage.setItem('main-nav-min', v ? 'true' : 'false');
		})
	);
	setNavMin(val: boolean) {
		this._navMin.next(val);
	}
	getCurrent() {
		return this._navMin.getValue();
	}
}
